<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-data-table :headers="headers" :items="users" class="elevation-1">
      <v-card-text>
        {{ allPermissions }}
      </v-card-text>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>USERS</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" width="1200px" persistent>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                outlined
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                New User <v-icon right>mdi-account-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.name"
                        label="Name"
                        :rules="[rules.required]"
                        outlined
                        dense
                        color="accent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.surname"
                        label="Surname"
                        :rules="[rules.required]"
                        outlined
                        dense
                        color="accent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.email"
                        label="E-mail"
                        :rules="emailRules"
                        outlined
                        dense
                        color="accent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" v-if="editedIndex === -1">
                      <v-text-field
                        type="password"
                        v-model="editedItem.password"
                        label="Password"
                        :rules="passwordRules"
                        outlined
                        dense
                        color="accent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.credentials"
                        label="Credentials"
                        :rules="[rules.required]"
                        outlined
                        dense
                        color="accent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        type="number"
                        v-model="editedItem.uniqueNumber"
                        label="Unique number"
                        :rules="[rules.required]"
                        min="0"
                        outlined
                        dense
                        color="accent"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select
                        v-model="editedItem.permissions"
                        :items="allPermissions"
                        :item-text="'name'"
                        :item-value="'name'"
                        label="Select permissions"
                        multiple
                        :rules="[rules.required]"
                        outlined
                        chips
                        small-chips
                        deletable-chips
                        color="accent"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" outlined @click="close"> Cancel </v-btn>
                <v-btn color="success" outlined @click="debouncedSave"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" width="unset" persistent>
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete user
                {{ userInfo }} ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" outlined @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="success" outlined @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="accent" @click="fetchUsers"> Reset </v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      top
      v-model="snackbar"
      color="#FF3232"
      class="white--text"
      width="800"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import { debounce } from 'lodash';
export default {
  data: () => ({
    valid: true,
    debouncedSave: null,
    dialog: false,
    dialogDelete: false,
    snackbar: false,
    snackbarText: "",
    userInfo: "",
    allPermissions: [],
    passwordRules: [
      (v) => !!v || "Password is required",
      (v) => (v && v.length >= 5) || "Password must have 5+ characters",
      (v) => /(?=.*[A-Z])/.test(v) || "Must have one uppercase character",
      (v) => /(?=.*\d)/.test(v) || "Must have one number",
    ],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@brandclub.lt+/.test(v) || "E-mail must be valid",
    ],
    rules: {
      required: (value) => !!value || "Field is required.",
    },
    headers: [
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Surname", align: "start", value: "surname" },
      { text: "E-mail", align: "start", value: "email" },
      {
        text: "Password",
        align: " d-none",
        value: "password",
        filterable: false,
      },
      { text: "Credentials", align: "start", value: "credentials" },
      { text: "Unique number", align: "start", value: "uniqueNumber" },
      {
        text: "Permissions",
        align: "start",
        value: "permissions",
        sortable: false,
      },
      { text: "Actions", align: "start", value: "actions", sortable: false },
    ],
    users: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      surname: "",
      email: "",
      password: "",
      credentials: "",
      uniqueNumber: "",
      permissions: [],
    },
    defaultItem: {
      name: "",
      surname: "",
      email: "",
      password: "",
      credentials: "",
      uniqueNumber: "",
      permissions: [],
    },
  }),
 
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.fetchUsers();
    this.fetchPermissions();
    this.debouncedSave = debounce(this.save, 500, { 
      leading: true,  
      trailing: false 
    });
  },
  onBeforeUnmount() {
    this.debouncedSave.cancel();
  },

  methods: {
    fetchUsers() {
      // getting users from server
      this.$store
        .dispatch("getUsers")
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => this.errors.push(error));
    },

    fetchPermissions() {
      // getting permissions list from server
      this.$store
        .dispatch("getPermissions")
        .then((response) => {
          this.allPermissions = response.data;
        })
        .catch((error) => console.log(error));
    },

    editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.users.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.userInfo = item.name + " " + item.surname;
    },

    deleteItemConfirm() {
      //deleting item
      this.$store
        .dispatch("deleteUser", this.editedItem.id)
        .then(() => {
          this.fetchUsers();
        })
        .catch((e) => {
          this.errors.push(e);
        });
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        //editing item
        if (this.editedIndex > -1) {
          this.putEditedUser();
        }
        //adding new item
        else {
          //check if email aleady exists
          if (this.users.some((e) => e.email === this.editedItem.email)) {
            this.snackbarText = "This e-mail already exists!";
            this.snackbar = true;
          } else if (
            this.users.some(
              (e) => e.uniqueNumber === this.editedItem.uniqueNumber
            )
          ) {
            this.snackbarText = "This unique number already exists!";
            this.snackbar = true;
          } else {
            this.postNewUser();
          }
        }
      }
    },
    putEditedUser() {
      //if you are editing currently logged in user, then compare permissions:
      let storagePermissions = localStorage.getItem("permissions");

      storagePermissions = storagePermissions.split(",");

      let permissionsEqual = this.arraysEqual(
        this.editedItem.permissions,
        storagePermissions
      );

      var currentUserId = localStorage.getItem("user-id");
      if (currentUserId == this.editedItem.id) {
        localStorage.setItem("permissions", this.editedItem.permissions);
      }
      let body = {
        data: {
          name: this.editedItem.name,
          surname: this.editedItem.surname,
          email: this.editedItem.email,
          uniqueNumber: this.editedItem.uniqueNumber,
          credentials: this.editedItem.credentials,
          permissions: this.editedItem.permissions,
        },
        id: this.editedItem.id,
      };

      this.$store
        .dispatch("editUser", body)
        .then(() => {
          //if editing currently logged in user, and edited permissions, then logout the user
          if (!permissionsEqual) {
            this.logout();
          } else {
            this.fetchUsers();
            this.dialog = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    logout() {
      localStorage.clear();
      this.$root.$emit("reload", "reload");
      this.$router.push("/login");
    },
    arraysEqual(a, b) {
      return (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index])
      );
    },
    postNewUser() {
      this.$store
        .dispatch("createUser", {
          name: this.editedItem.name,
          surname: this.editedItem.surname,
          email: this.editedItem.email,
          password: this.editedItem.password,
          uniqueNumber: this.editedItem.uniqueNumber,
          credentials: this.editedItem.credentials,
          permissions: this.editedItem.permissions,
        })
        .then(() => {
          this.fetchUsers();
          this.dialog = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>
